import {
  FILTERS_ALL_FAIL,
  FILTERS_ALL_OK,
  FILTERS_ALL_REQUESTED,
} from "actions/filters";

function createReversedArrayWithLabels(number) {
  const array = [];
  for (let i = number; i >= 0; i--) {
    array.push({ value: i, label: i.toString() });
  }
  return array;
}

const INITIAL_STATE = {
  filters: [],
  isLoading: false,
  errors: false,
};

export function filtersReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FILTERS_ALL_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };

    case FILTERS_ALL_OK:
      const payload = action.payload;
      const sending_ids = createReversedArrayWithLabels(
        payload.filters.max_sending_id
      );
      payload.filters.sending_ids = sending_ids;
      return {
        ...payload,
        sending_ids: sending_ids,
        isLoading: false,
        errors: false,
      };

    case FILTERS_ALL_FAIL:
      return {
        ...state,
        isLoading: false,
        errors: true,
      };

    default:
      return state;
  }
}
